import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M35.87 2.48A24.9 24.9 0 0 0 25 0a24.9 24.9 0 0 0-10.87 2.48L11.956 25l2.174 22.52A24.9 24.9 0 0 0 25 50a24.9 24.9 0 0 0 10.87-2.48L38.042 25 35.87 2.48Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M14.13 2.481C5.768 6.525 0 15.088 0 25c0 9.911 5.768 18.474 14.13 22.518V2.481Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M35.87 2.481v45.037C44.232 43.474 50 34.911 50 25c0-9.912-5.768-18.475-14.13-22.519Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#fff",
  d: "M25 16.304a8.695 8.695 0 1 0 0 17.391 8.695 8.695 0 0 0 0-17.39Zm0 14.13a5.435 5.435 0 1 1 0-10.869 5.435 5.435 0 0 1 0 10.87Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#fff",
  d: "M25 21.738c-1.2 0-2.174.973-2.174 2.174v3.261h4.348v-3.26c0-1.202-.973-2.175-2.174-2.175Z"
}));
FlagAF.displayName = 'FlagAF';
export default withFlagWrapper(FlagAF);
//# sourceMappingURL=index.js.map